<span class="te-holder">
  <span class="split" [style.-webkit-line-clamp]="lines" [title]="text">{{ text }}</span>
</span>
<!--span  class="text-overflow" [title]="text">{{text}}</span-->
